import {Component, Object3D} from '@wonderlandengine/api';
import {hapticFeedback} from '../utils/haptic-feedback.js';
import {GameManagerInstance, SceneNames} from '../managers/gamemanager.js';
import {Cursor, CursorTarget} from '@wonderlandengine/components';
import {PhongMaterial} from '../types/materials.js';
import {property} from '@wonderlandengine/api/decorators.js';
import {Blink} from './blink.js';

/**
 * intro-begin
 */
export class IntroBegin extends Component {
    static TypeName = 'intro-begin';

    @property.object({required: true})
    blinkSphereObject!: Object3D;

    private target?: CursorTarget;
    private clicked = false;
    private blink?: Blink;

    start() {
        /* Add Cursor Functions */
        this.target =
            this.object.getComponent(CursorTarget) ||
            this.object.addComponent(CursorTarget)!;

        /* Clone objectHover material, to only affect this object's material */
        this.object.parent!.getComponents('mesh').forEach((a) => {
            a.material = a.material!.clone();
        });

        const tempTextFade = this.blinkSphereObject.getComponent(Blink);
        if (!tempTextFade) {
            throw new Error(
                `intro-begin(${this.object.name}): blinkSphereObject does not have a TextFadetempTextFade`
            );
        }
        this.blink = tempTextFade;
    }

    onActivate(): void {
        this.target!.onHover.add(this.onHover.bind(this));
        this.target!.onUnhover.add(this.onUnHover.bind(this));
        this.target!.onDown.add(this.onDown.bind(this));
    }
    onDeactivate(): void {
        this.target!.onHover.remove(this.onHover.bind(this));
        this.target!.onUnhover.remove(this.onUnHover.bind(this));
        this.target!.onDown.remove(this.onDown.bind(this));
    }

    onHover(_: Object3D, cursor: Cursor) {
        hapticFeedback(cursor.object, 0.5, 50);
        /* Highlight */
        this.object.parent!.getComponents('mesh').forEach((a) => {
            const material = a.material as PhongMaterial;
            material.emissiveColor = [0.12, 0.12, 0.12, 1];
        });
    }

    onUnHover(_: Object3D, cursor: Cursor) {
        hapticFeedback(cursor.object, 0.3, 50);
        /* Highlight Reset to Default */
        this.object.parent!.getComponents('mesh').forEach((a) => {
            const material = a.material as PhongMaterial;
            material.emissiveColor = [0, 0, 0, 1];
        });
    }

    onDown() {
        if (this.clicked) {
            return;
        }
        this.clicked = true;
        this.blink!.startBlink(null, this.loadScene, false, null, true);
    }

    loadScene = () => {
        GameManagerInstance.loadScene(SceneNames.Scene1);
    };
}
